module.exports = __webpack_public_path__ + "assets/ic-coinmarketcap.106f33eb.svg";